import React from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const statisticsData = [
  {
    title: "One",
    description: "Account for global money management.",
  },
  {
    title: "21",
    description: "Currencies supported on the platform.",
  },
  {
    title: "120",
    description: "Countries supported on our system.",
  },
  {
    title: "Up to 60%",
    description: "Cost optimisation using our technology.",
  },
];

interface StatisticItemProps {
  title: string;
  description: string;
}

const StatisticItem: React.FC<StatisticItemProps> = ({ title, description }) => (
  <div className="flex flex-col items-start h-full p-6 bg-gray-100 rounded-3xl border border-gray-100 cursor-pointer transition-all duration-300 hover:border-indigo-700 hover:text-slate-800">
    <h3 className="text-2xl font-semibold text-indigo-700 mb-2">{title}</h3>
    <p className="text-gray-700 text-base">{description}</p>
  </div>
);

const StatsHomepage: React.FC = () => {
  return (
    <section className="container max-w-screen-2xl py-12">
      <Swiper
        spaceBetween={24}
        slidesPerView={1.3}
        centeredSlides={false}
        navigation={false}
        pagination={{
          clickable: true,
          el: ".swiper-pagination",
        }}
        breakpoints={{
          640: {
            slidesPerView: 1.7,
          },
          1024: {
            slidesPerView: 4,
            pagination: false,
          },
        }}
        modules={[Navigation, Pagination]}
        className="w-full [&_.swiper-wrapper]:!items-stretch"
      >
        {statisticsData.map((item, index) => (
          <SwiperSlide key={index} className="h-auto">
            <StatisticItem title={item.title} description={item.description} />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="swiper-pagination mt-6 md:hidden"></div>
    </section>
  );
};

export default StatsHomepage;
